import { render } from "./ErrorMsg.vue?vue&type=template&id=06f2add3&scoped=true"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"

import "./ErrorMsg.vue?vue&type=style&index=0&id=06f2add3&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f2add3"]])

export default __exports__